import { copyValues } from '@iris/common/utils/object.utils';

export interface IrisThemeI {
  strabagControlsEnabled: boolean;
  strabagColorsEnabled?: boolean;
  darkModeEnabled?: boolean;
}

export class IrisTheme implements IrisThemeI {
  strabagControlsEnabled = false;
  strabagColorsEnabled = false;
  darkModeEnabled = false;

  constructor(params?: IrisThemeI) {
    if (params) {
      copyValues(this, params);
    }
  }
}
